import { type RefLabel, appRefLabels } from "@/domain/reflabel/constants"
import { useGetCountriesRefLabels, useGetLocalesRefLabels, useGetRefLabels } from "@/networking/api"
import { createContext, useContext } from "react"

type AppRefLabel = (typeof appRefLabels)[number]

interface IRefLabels {
  reflabels: RefLabel[]
  getAppRefLabel: (code: AppRefLabel) => RefLabel | null
  countries: RefLabel[]
  locales: RefLabel[]
  isCountriesLoading: boolean
  isLocalesLoading: boolean
}

export const refLabelsContext = createContext<IRefLabels>({
  reflabels: [],
  getAppRefLabel: () => null,
  countries: [],
  locales: [],
  isCountriesLoading: false,
  isLocalesLoading: false,
})

export function AppRefLabelsContext(props: React.PropsWithChildren) {
  const { data } = useGetRefLabels({
    "code[]": [...appRefLabels],
  })

  const reflabels = (data?.["hydra:member"] ?? []) as RefLabel[]

  const getAppRefLabel = (code: AppRefLabel) => {
    const reflabels = data?.["hydra:member"] ?? []
    for (const reflabel of reflabels) {
      if (reflabel?.code === code) return reflabel as RefLabel
    }

    return null
  }

  const { data: rfl_countries, isLoading: isCountriesLoading } = useGetCountriesRefLabels({
    itemsPerPage: 300,
  })
  const countries: RefLabel[] = (rfl_countries?.["hydra:member"] ?? []) as RefLabel[]
  /*.sort((la, lb) =>
    (la.label ?? "-") > (lb.label ?? "-") ? 1 : -1
  )*/

  const { data: rfl_locales, isLoading: isLocalesLoading } = useGetLocalesRefLabels({
    itemsPerPage: 300,
  })
  const locales: RefLabel[] = (rfl_locales?.["hydra:member"] ?? []) as RefLabel[]
  /*.sort((la, lb) =>
    (la.label ?? "-") > (lb.label ?? "-") ? 1 : -1
  )*/

  return (
    <refLabelsContext.Provider
      value={{
        reflabels,
        getAppRefLabel,
        countries,
        locales,
        isCountriesLoading,
        isLocalesLoading,
      }}
    >
      {props.children}
    </refLabelsContext.Provider>
  )
}

export const useRefLabelsContext = () => useContext(refLabelsContext)
